import { Button, ButtonGroup, ClickAwayListener } from '@material-ui/core';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import RecentSearch from './RecentSearch';
//import RecentSearchItem from './RecentSearchItem';
import SearchLanguage from './SearchLanguage';
import SearchOptions from './SearchOptions';
import './SourceSearchPanel.css';

interface Props {
    searchBoxId: string;
    //currentLanguage: SearchLanguage;
    options: SearchOptions;
    recentSearches: RecentSearch[];
    onOptionsChange: (options: SearchOptions) => void;
    //onLanguageClick: (language: SearchLanguage) => void;
    onRecentSearchClick: (search: RecentSearch) => void;
    onRecentSearchRemoveClick: (search: RecentSearch) => void;
    onClickAway: () => void;
}

interface State {
    left: number;
    top: number;
    width: number;
}

export default class SourceSearchPanel extends React.Component<Props, State> {

    private searchBox: HTMLElement;

    public constructor(props: Props) {
        super(props);
        this.state = {
            left: 0,
            top: 0,
            width: 0
        };
        //this.onEnglishClick = this.onEnglishClick.bind(this);
        //this.onHebrewClick = this.onHebrewClick.bind(this);
        //this.onGreekClick = this.onGreekClick.bind(this);
        this.onEnglishClick2 = this.onEnglishClick2.bind(this);
        this.onHebrewClick2 = this.onHebrewClick2.bind(this);
        this.onGreekClick2 = this.onGreekClick2.bind(this);
        this.onSearchAllClick = this.onSearchAllClick.bind(this);
        this.onSearchTickedClick = this.onSearchTickedClick.bind(this);
        this.onSearchStemsClick = this.onSearchStemsClick.bind(this);
    }

    public componentDidMount() {
        const searchBox = document.getElementById(this.props.searchBoxId);
        if (!searchBox) {
            throw new Error('Invalid search box ID: ' + this.props.searchBoxId);
        }
        this.searchBox = searchBox;

        const rect = searchBox.getBoundingClientRect();
        this.setState({
            left: rect.left,
            top: rect.bottom,
            width: rect.width
        });
    }

    public render() {
        const style = {
            left: this.state.left,
            top: this.state.top,
            width: this.state.width
        };

        const content = (
            <ClickAwayListener onClickAway={this.props.onClickAway}>
                <div className="SourceSearchPanel" style={style}>
                    {/*<div>
                        <button className={this.getLanguageClasses(SearchLanguage.English)} onClick={this.onEnglishClick2}>English</button>
                        <button className={this.getLanguageClasses(SearchLanguage.Hebrew)} onClick={this.onHebrewClick2}>Hebrew</button>
                        <button className={this.getLanguageClasses(SearchLanguage.Greek)} onClick={this.onGreekClick2}>Greek</button>
                    </div>*/}

                    <ButtonGroup color="secondary" size="small" fullWidth={true} disableRipple={true}>
                        <Button disableRipple={true} variant={this.props.options.language === SearchLanguage.English ? 'contained' : undefined} onClick={this.onEnglishClick2}>English</Button>
                        <Button disableRipple={true} variant={this.props.options.language === SearchLanguage.Hebrew ? 'contained' : undefined} onClick={this.onHebrewClick2}>Hebrew</Button>
                        <Button disableRipple={true} variant={this.props.options.language === SearchLanguage.Greek ? 'contained' : undefined} onClick={this.onGreekClick2}>Greek</Button>
                    </ButtonGroup>

                    <ButtonGroup color="secondary" size="small" fullWidth={true} disableRipple={true}>
                        <Button disableRipple={true} variant={this.props.options.searchAllVersions ? 'contained' : undefined} onClick={this.onSearchAllClick}>All Versions</Button>
                        <Button disableRipple={true} variant={!this.props.options.searchAllVersions ? 'contained' : undefined} onClick={this.onSearchTickedClick}>Ticked Versions</Button>
                    </ButtonGroup>

                    <ButtonGroup color="secondary" size="small" fullWidth={true} disableRipple={true}>
                        <Button disableRipple={true} variant={this.props.options.searchStems ? 'contained' : undefined} onClick={this.onSearchStemsClick}>Search Stems</Button>
                    </ButtonGroup>

                    {/*<FormControlLabel
                        control={<Checkbox
                            checked={this.props.options.searchStems}
                            onChange={undefined}
                            color="primary" />}
                        label="Also search stems" />*/}

                    {/*this.props.recentSearches.length > 0 && <div className="SourceSearchPanel_RecentSearches">
                        <div className="SourceSearchPanel_RecentSearchesHeader">Recent searches</div>
                        <div className="SourceSearchPanel_RecentSearchList">
                            {this.props.recentSearches.map(search =>
                                <RecentSearchItem
                                    key={search.getId()}
                                    search={search}
                                    onClick={this.props.onRecentSearchClick}
                                    onRemoveClick={this.props.onRecentSearchRemoveClick} />
                            )}
                        </div>
                    </div>*/}

                    {/*<div style={{ color: 'dimgray', textAlign: 'center', marginBottom: '2px' }}>Press Enter to search</div>*/}
                </div>
            </ClickAwayListener>
        );

        return ReactDOM.createPortal(content, document.body);
    }

    /*private getLanguageClasses(language: SearchLanguage): string {
        const classes = ['SourceSearchPanel_Language'];
        if (language === this.props.options.language) {
            classes.push('SourceSearchPanel_SelectedLanguage');
        }
        return classes.join(' ');
    }*/

    /*private onEnglishClick() {
        this.props.onLanguageClick(SearchLanguage.English);
        this.searchBox.focus();
    }

    private onHebrewClick() {
        this.props.onLanguageClick(SearchLanguage.Hebrew);
        this.searchBox.focus();
    }

    private onGreekClick() {
        this.props.onLanguageClick(SearchLanguage.Greek);
        this.searchBox.focus();
    }*/

    private onEnglishClick2() {
        //this.props.onLanguageClick(SearchLanguage.English);
        this.updateOptions({ language: SearchLanguage.English });
        this.searchBox.focus();
    }

    private onHebrewClick2() {
        this.updateOptions({ language: SearchLanguage.Hebrew });
        //this.props.onLanguageClick(SearchLanguage.Hebrew);
        //this.searchBox.focus();
    }

    private onGreekClick2() {
        this.updateOptions({ language: SearchLanguage.Greek });
        //this.props.onLanguageClick(SearchLanguage.Greek);
        //this.searchBox.focus();
    }

    private onSearchAllClick() {
        this.updateOptions({ searchAllVersions: true });
        //this.searchBox.focus();
    }

    private onSearchTickedClick() {
        this.updateOptions({ searchAllVersions: false });
        //this.searchBox.focus();
    }

    private onSearchStemsClick() {
        this.updateOptions({ searchStems: !this.props.options.searchStems });
        //this.searchBox.focus();
    }

    private updateOptions(options: Partial<SearchOptions>) {
        //this.setState(prevState => ({ options: Object.assign(prevState.options, options) }), () => this.props.onOptionsChange(this.state.options));
        this.props.onOptionsChange(Object.assign({}, this.props.options, options));
    }
}
